import { createRouter, createWebHistory } from 'vue-router'
import admin from './admin/index.js'
import security from './security/index.js'
import organizer from './organizer/index.js'
import bidder from '@/router/bidder/index.js'
import biddingProcedure from '@/router/biddingProcedure/index.js'
import notification from '@/router/notification/index.js'
import showCaseUnauthorizedMeta from '@/router/showCaseUnauthorized/index.js'
import { checkPermissionForResetPassword } from '@/http/auth/authApi.js'
import { authMiddleware } from '@/router/middleware/auth.middleware.js'
import { notificationMiddleware } from '@/router/middleware/notification.middleware.js'
import { paginationMiddleware } from '@/router/middleware/pagination.middleware.js'
import { filterMiddleware } from './middleware/filter.middleware.js'
import bidderMeta from '@/router/bidder/bidderMeta.js'
import { checkRole } from '@/utils/utils.js'
import { Alert } from '@/extension/Alert/Alert.js'

let routes = [
  {
    path: '/:notFound(.*)',
    redirect: { name: 'admin' },
  },
  {
    path: '/loading',
    name: 'spinner',
    component: () => import('../components/views/Spinner/VSpinner.vue'),
    meta: {
      layout: 'auth-layout',
    },
  },
  {
    path: '/work',
    name: 'work',
    component: () => import('../components/views/Spinner/VSpinner.vue'),
    meta: {
      layout: 'auth-layout',
    },
    async beforeEnter(to, from, next) {
      const isWork = true
      if (isWork) {
        next()
      } else {
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('../views/Auth/RegistrationView.vue'),
    meta: {
      layout: 'auth-layout',
      login: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Auth/LoginView.vue'),
    meta: {
      layout: 'auth-layout',
      login: true,
    },
  },
  {
    path: '/change-password',
    name: 'reset',
    component: () => import('../views/Auth/ResetPasswordView.vue'),
    meta: {
      layout: 'auth-layout',
      login: true,
    },
    async beforeEnter(to, from, next) {
      try {
        await checkPermissionForResetPassword(to.query)
        next()
      } catch (e) {
        next({ name: 'login' })
      }
    },
  },
]

const additionalRoutes = [
  ...admin,
  ...security,
  ...bidder,
  ...security,
  ...organizer,
  ...biddingProcedure,
  ...notification,
  ...showCaseUnauthorizedMeta,
]

routes = [...routes, ...additionalRoutes]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(authMiddleware)
router.beforeEach(filterMiddleware)
router.beforeEach(notificationMiddleware)
router.beforeEach(paginationMiddleware)

export default router
